var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('div',{staticClass:"scroll-to-top",on:{"click":_vm.scrollToTop}},[_vm._v(" ↑ ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }